import { Stack } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { ModalWrapper } from '@styles/StyledDiv';
import { Modal } from 'app/shared/components/modals/Modal';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { dataGridCol } from '@shared/components/grid/common';
import { ISubprimeResponse, SubprimeType } from '../interfaces';

interface ISubprimeResponseModalProps {
  open: boolean;
  onClose: () => void;
  data: ISubprimeResponse[];
  modalFor?: string;
}

export const SubprimeResponseModal = ({ open, onClose, data, modalFor }: ISubprimeResponseModalProps) => {
  const columns: GridColDef[] = useMemo(
    () => [
      dataGridCol('dealNumericId', {
		headerName: 'Deal Id',
        minWidth: 100,
        flex: 0.5,
      }),
      dataGridCol('lenderName', {
        headerName: 'Lender',
        minWidth: 100,
        flex: 1,
      }),
      dataGridCol(modalFor === SubprimeType.createDeals ? 'success' : 'isSuccess', {
        headerName: 'Success',
        minWidth: 40,
        flex: 0.5,
        valueFormatter: ({ value }) => value?.toString(),
      }),
      dataGridCol('message', {
        minWidth: 150,
        flex: 2,
      }),
    ],
    [modalFor]
  );
  
  return (
    <Modal
      open={open}
      dialogWidth="850px"
      title={modalFor === SubprimeType.createDeals? 'Created Deals' : 'Submitted Deals'}
      onClose={onClose}
    >
      <ModalWrapper>
        <Stack spacing={2}>
          <PhoenixGrid
            canNotCopy
            hideFooter
            autoHeight
            disableSelectionOnClick
            name="Created Deals"
            columns={columns}
            loading={!data}
            rows={data}
            getRowId={(row) => row?.dealId}
          />
        </Stack>
      </ModalWrapper>
    </Modal>
  );
};
